import { useFieldContext } from "./form-context";
import { Label } from "../ui/label";
import { Combobox } from "../ui/combobox";

export function FormCombobox({
  label,
  id,
  description,
  options,
  placeholder,
}: {
  label: string;
  id: string;
  description: string;
  options: { value: string; label: string }[];
  placeholder: string;
}) {
  const field = useFieldContext<string>();
  return (
    <div className="flex flex-col gap-2 w-full">
      <Label htmlFor={id}>{label}</Label>
      <Combobox options={options} placeholder={placeholder} />
      <div className="text-sm form-description">{description}</div>
    </div>
  );
}
